import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { BoxPlot } from "../components/BoxPlot";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.box_tool_name()}
        toolPath="/box-plot"
      />
      <SciHeader title={m.box_h1()} intro={m.box_intro()} />

      <BoxPlot />

      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.box_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.box_ex1(), m.box_ex2(), m.box_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.box_faq_q1(), a: m.box_faq_a1() },
          { q: m.box_faq_q2(), a: m.box_faq_a2() },
          { q: m.box_faq_q3(), a: m.box_faq_a3() },
          { q: m.box_faq_q4(), a: m.box_faq_a4() },
        ]}
      />

      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
